import { render } from "./Town.vue?vue&type=template&id=66b746d0"
import script from "./Town.vue?vue&type=script&lang=js"
export * from "./Town.vue?vue&type=script&lang=js"

import "./Town.vue?vue&type=style&index=0&id=66b746d0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__